import React, {useEffect, useState} from "react";
import {Autocomplete, Box, Button, FormControl, FormGroup, Grid, TextField} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutlined";
import {DateTimePicker, LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {useGetGuidMapRTQuery} from "../../../core/api/rogerthat-charge-api";

export default function Guid2Block(props) {
    const [stringArgs, setStringArgs] = useState(0)
    const [amount, setAmount] = useState(0)
    const [guid2, setGuid2] = useState(null)
    const [endTime, setEndTime] = useState(null)
    const [guid, setGuid] = useState(null)


    const {
        data: guidMap,
    } = useGetGuidMapRTQuery()

    useEffect(() => {
        let newValidateChildrenList = [...props.validateChildrenList]
        if (props.resetData) {
            setGuid(null);
            setGuid2(null);
        }
        newValidateChildrenList[props.index] = !checkChargeButtonDisable()
        props.setValidateChildrenList(newValidateChildrenList)
        console.log("")

        // props.setChargeButtonDisable(checkChargeButtonDisable());
    }, [guid, guid2, props.selectedITemList[props.index]])

    const checkChargeButtonDisable = () => {

        return (((props.selectedITemList[props.index]["item"].guidMap !== "") && guid == null) ||
            ((props.selectedITemList[props.index]["item"].guidMap2 !== "") && guid2 == null))

        // for (let item in props.selectedITemList) {
        //     if (!props.selectedITemList[item]["item"].hasOwnProperty("value") ||
        //         ((props.selectedITemList[item]["item"].guidMap!=="") && guid==null ) ||
        //         ((props.selectedITemList[item]["item"].guidMap2 !== null) && guid2==null)) {
        //         return true;
        //     }
        // }
        // return false
    }

    const handleChangeAmount = (event) => {
        setAmount(event.target.value)
        let newItem = {...props.selectedITemList[props.index], "amount": event.target.value};
        let newSelectedItemList = [...props.selectedITemList];
        newSelectedItemList[props.index] = newItem;
        props.setSelectedItemList(newSelectedItemList);
    }
    const handleChangeStringArgs = (event) => {
        setAmount(event.target.value)
        let newItem = {...props.selectedITemList[props.index], "stringArgs": event.target.value};
        let newSelectedItemList = [...props.selectedITemList];
        newSelectedItemList[props.index] = newItem;
        props.setSelectedItemList(newSelectedItemList);
    }
    const handleChangeItem2 = (event, values) => {
        props.setResetData(false)
        setGuid2(values)
        let newItem = {...props.selectedITemList[props.index], "guid2": values};
        let newSelectedItemList = [...props.selectedITemList];
        newSelectedItemList[props.index] = newItem;
        props.setSelectedItemList(newSelectedItemList);
    }

    function showAmount(selectedItem) {
        return selectedItem.hasOwnProperty("amount") && selectedItem.amount == true
    }

    function showStringArgs(selectedItem) {
        return selectedItem.hasOwnProperty("stringArgs") && selectedItem.stringArgs == true
    }

    function showEndtime(selectedItem) {
        return selectedItem.hasOwnProperty("endTime") && selectedItem.endTime == true
    }

    const handleChangeItem = (event, values) => {
        setAmount(0);
        props.setResetData(false)
        setGuid(values)

        let newItem = {...props.selectedITemList[props.index], "guid": values};
        newItem.amount = 0;
        let newSelectedItemList = [...props.selectedITemList];
        newSelectedItemList[props.index] = newItem;
        props.setSelectedItemList(newSelectedItemList);
    }

    const handleAddItem = () => {
        let newSelectedItemList = [...props.selectedITemList];
        newSelectedItemList.push({"item": props.selectedItem});
        props.setSelectedItemList(newSelectedItemList)
    }

    const handleRemoveItem = () => {
        let newSelectedItemList = [...props.selectedITemList];
        newSelectedItemList.splice(props.index, 1);
        props.setSelectedItemList(newSelectedItemList)
        let newValidateChildrenList = [...props.validateChildrenList];
        newValidateChildrenList.splice(props.index, 1);
        props.setValidateChildrenList(newValidateChildrenList);
    }

    const handleSetTime = (value) => {
        setEndTime(value)

        let newItem = {...props.selectedITemList[props.index], "endTime": value};
        let newSelectedItemList = [...props.selectedITemList];
        newSelectedItemList[props.index] = newItem;
        props.setSelectedItemList(newSelectedItemList);
    }

    function showAddButton(selectedItem) {
        return selectedItem.guidMap !== null && selectedItem.guidMap !== ""
            || selectedItem.guidMap2 !== null && selectedItem.guidMap2 !== ""
    }

    return (
        <>
            {(guidMap && guidMap.hasOwnProperty(props.selectedItem.guidMap) && props.selectedItem.guidMap != null) &&
                <FormGroup sx={{pb: 2, pt: 2}}>
                    <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={guidMap[props.selectedItem.guidMap]}
                        getOptionLabel={(item) => item.displayName || ""}
                        value={props.selectedITemList[props.index].guid === undefined ? "" : props.selectedITemList[props.index].guid}
                        onChange={handleChangeItem}
                        renderOption={(props, option) => (
                            <li {...props} key={option.guid}>
                                {option.displayName}
                            </li>
                        )}
                        renderInput={(params) => <TextField {...params} label={props.selectedItem.guidMap}/>}
                    />

                </FormGroup>
            }
            {props.selectedItem && (props.selectedItem.guidMap2 != null && props.selectedItem.guidMap2 != "") &&
                <FormGroup sx={{pb: 2}}>
                    <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={guidMap[props.selectedItem.guidMap2]}
                        getOptionLabel={(item) => item.displayName}
                        value={guid2}
                        onChange={handleChangeItem2}
                        renderOption={(props, option) => (
                            <li {...props} key={option.guid}>
                                {option.displayName}
                            </li>
                        )}
                        renderInput={(params) => <TextField {...params} label={props.selectedItem.guidMap2}/>}
                    />

                </FormGroup>
            }
            <Grid container spacing={2} sx={{pb: 1}}>
                {showAmount(props.selectedItem) && <Grid xs={6}>
                    <FormGroup sx={{pb: 2}}>
                        <FormControl fullWidth>
                            <TextField
                                variant="outlined"
                                value={props.selectedITemList[props.index].amount}
                                label={props.selectedItem.amountAttribute || "Amount"}
                                onChange={handleChangeAmount}
                                type="number"
                            />

                        </FormControl>
                    </FormGroup>

                </Grid>}

                {showStringArgs(props.selectedItem) && <Grid xs={6}>
                    <FormGroup sx={{pb: 2}}>
                        <FormControl fullWidth>
                            <TextField
                                variant="outlined"
                                value={props.selectedITemList[props.index].stringArgs}
                                label="stringArgs"
                                onChange={handleChangeStringArgs}

                            />

                        </FormControl>
                    </FormGroup>

                </Grid>}

                {showEndtime(props.selectedItem) && <Grid xs={6}>
                    <FormGroup sx={{pb: 2}}>

                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DateTimePicker
                                label="Select Date and Time"
                                inputVariant="outlined"
                                value={endTime}
                                ampm={false}
                                onChange={(newValue) => handleSetTime(newValue)}
                                format={'DD/MM/YYYY HH:mm'}

                            />
                        </LocalizationProvider>

                    </FormGroup>
                </Grid>}
                {/* Action Buttons — same layout as toh/mc/ds */}
                <Grid container spacing={1} sx={{mt: 1, ml: 2}}>
                    {(props.index !== 0 || (props.index === 0 && props.selectedITemList.length > 1)) && <Grid>
                        <Button
                            variant="outlined"
                            color="error"
                            startIcon={<DeleteIcon/>}
                            onClick={handleRemoveItem}
                        >
                            Remove
                        </Button>
                    </Grid>}
                    {props.index === props.selectedITemList.length - 1 && showAddButton(props.selectedItem) &&
                        <Grid>
                            <Button
                                disabled={props.addButtonDisabled}
                                variant="outlined"
                                color="info"
                                startIcon={<AddCircleOutlineIcon/>}
                                onClick={handleAddItem}
                            >
                                Add
                            </Button>
                        </Grid>}
                </Grid>
            </Grid>
        </>
    );
}
